import React from 'react'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import Loader from '../Loader'
import { useState, useEffect } from 'react'
import { FaUserAlt, FaAngleDown } from "react-icons/fa";
import { IoMdNotifications } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import './userdashboardranking.css'
import MobileDropdown from '../MobileDropdown'
import { getData } from '../../api/user'
import { useAuth } from '../../context/AuthContext'
import { isAuthError } from '../../auth/tokenStorage'

const UserdashboardRanking = () => {
  const [userData, setUserData] = useState()
  const [loader, setLoader] = useState(false)
  const [showMobileDropdown, setShowMobileDropdown] = useState(false)
  const navigate = useNavigate()
  const { isAuthenticated, logout } = useAuth()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);

        if (!isAuthenticated) {
          navigate('/login');
          return;
        }

        const data = await getData();

        // Handle errors from the API
        if (isAuthError(data)) {
          logout(); // Clear invalid token
          navigate('/login');
        } else if (data.status !== 'error') {
          setUserData(data); // Set user data
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        navigate('/login'); // Navigate to login on failure
      } finally {
        setLoader(false); // Stop loader
      }
    };

    fetchData();
  }, [navigate, isAuthenticated, logout]);

  const closeMobileMenu = () => {
    setShowMobileDropdown(false)
  }
  return (
    <main className='homewrapper'>
      {
        loader &&
        <Loader />
      }
      <Userdashboardheader />
      <section className='dashboardhomepage'>
        <div className="dashboardheaderwrapper">
          <div className="header-notification-icon-container">
            <IoMdNotifications />
          </div>
          <div className="header-username-container">
            <h3>Hi, {userData ? userData.firstname : ''}</h3>
          </div>
          <div className="header-userprofile-container">
            <div className="user-p-icon-container">
              <FaUserAlt />
            </div>
            <div className="user-p-drop-icon" onClick={() => { setShowMobileDropdown(!showMobileDropdown); }
            }>
              <FaAngleDown />
            </div>
            <MobileDropdown showStatus={showMobileDropdown} closeMenu={closeMobileMenu} />
          </div>
        </div>
        <div className="current-rank-section">
          <div className="active-trader-container">
            <div className="videoframe-text-container treader-header">
              <h1>Your current <span className="highlight">Rank</span></h1>
            </div>
            <div className="traders-card active-trader-card">
              <div className="trader-card-header">
                <div className="trader-card-image-container">
                  <img
                    src={`${userData
                        ? userData.funded > 20000
                          ? '/diamond.png'
                          : userData.funded > 5000
                            ? '/download-removebg-preview (2).png'  // Gold image
                            : '/images-removebg-preview.png'        // Silver image
                        : ''
                      }`}
                    alt=""
                    className='trader-card-image'
                  />

                  <div className="trader-card-text-container">
                    <h3 className="trader-name">
                      {userData
                        ? userData.funded > 20000
                          ? "diamond"
                          : userData.funded > 5000
                            ? "gold"
                            : "silver"
                        : ""}
                    </h3>
                  </div>

                </div>
              </div>
              <div className="trader-perfomance-container">
                <div className="trader-performance">
                  <div className="trader-performance-item">
                    <p className="performance-label">capital Range</p>
                    <p className="performance-value my-value">{`${userData
                        ? userData.funded > 20000
                          ? '$20,001 - unlimited' //diamond
                          : userData.funded > 5000
                            ? '$5001- $20,000'  // Gold 
                            : '$0- $5,000'        // Silver 
                        : ''
                      }`}</p>
                  </div>
                  <div className="trader-performance-item">
                    <p className="performance-label">bonus</p>
                    <p className="performance-value my-value"> {`${userData
                        ? userData.funded > 20000
                          ? '$500' //diamond
                          : userData.funded > 5000
                            ? '$100'  // Gold 
                            : '$50'        // Silver 
                        : ''
                      }`}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="videoframe-text-container treader-header">
          <h1>other <span className="highlight">Ranks</span></h1>
        </div>
        <div className="traders-card-container rank-plan-container">
          <div className="traders-card">
            <div className="trader-card-header">
              <div className="trader-card-image-container">
                <img src={`/images-removebg-preview.png`} alt="" className='trader-card-image' />
              </div>
              <div className="trader-card-text-container">
                <h3 className="trader-name">silver</h3>
                <p className="trader-description">Rank</p>
              </div>
            </div>
            <div className="trader-perfomance-container">
              <div className="trader-performance">
                <div className="trader-performance-item">
                  <p className="performance-label">capital Range</p>
                  <p className="performance-value my-value"> $0- $5,000</p>
                </div>
                <div className="trader-performance-item">
                  <p className="performance-label">bonus</p>
                  <p className="performance-value my-value"> $50</p>
                </div>
              </div>
              <div className="trader-performance-btn-container">
                <button className='trader-card-btn' onClick={() => { navigate('/withdraw') }}>downgrade</button>
              </div>
            </div>
          </div>
          <div className="traders-card">
            <div className="trader-card-header">
              <div className="trader-card-image-container">
                <img src={`/download-removebg-preview (2).png`} alt="" className='trader-card-image' />
              </div>
              <div className="trader-card-text-container">
                <h3 className="trader-name">Gold</h3>
                <p className="trader-description">Rank</p>
              </div>
            </div>
            <div className="trader-perfomance-container">
              <div className="trader-performance">
                <div className="trader-performance-item">
                  <p className="performance-label">capital Range</p>
                  <p className="performance-value my-value"> $5,001- $20,000</p>
                </div>
                <div className="trader-performance-item">
                  <p className="performance-label">bonus</p>
                  <p className="performance-value my-value"> $100</p>
                </div>
              </div>
              <div className="trader-performance-btn-container">
                <button className='trader-card-btn' onClick={() => { navigate('/fundwallet') }}>upgrade</button>
              </div>
            </div>
          </div>
          <div className="traders-card">
            <div className="trader-card-header">
              <div className="trader-card-image-container">
                <img src={`/diamond.png`} alt="" className='trader-card-image' />
              </div>
              <div className="trader-card-text-container">
                <h3 className="trader-name">diamond</h3>
                <p className="trader-description">Rank</p>
              </div>
            </div>
            <div className="trader-perfomance-container">
              <div className="trader-performance">
                <div className="trader-performance-item">
                  <p className="performance-label">capital Range</p>
                  <p className="performance-value my-value"> $20,001- $50,000</p>
                </div>
                <div className="trader-performance-item">
                  <p className="performance-label">bonus</p>
                  <p className="performance-value my-value" > $500</p>
                </div>
              </div>
              <div className="trader-performance-btn-container">
                <button className='trader-card-btn' onClick={() => { navigate('/fundwallet') }}>upgrade</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default UserdashboardRanking